import { FC, SVGProps } from 'react'

export const IconFileSignature: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke="#81899B"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 19.5V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V4C4 3.46957 4.21071 2.96086 4.58579 2.58579C4.96086 2.21071 5.46957 2 6 2H14.5L18 5.5"
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 18H9"
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.42 9.60998C18.615 9.41497 18.8465 9.26027 19.1013 9.15473C19.3561 9.04919 19.6292 8.99487 19.905 8.99487C20.1808 8.99487 20.4539 9.04919 20.7087 9.15473C20.9635 9.26027 21.195 9.41497 21.39 9.60998C21.585 9.80499 21.7397 10.0365 21.8452 10.2913C21.9508 10.5461 22.0051 10.8192 22.0051 11.095C22.0051 11.3708 21.9508 11.6439 21.8452 11.8987C21.7397 12.1535 21.585 12.385 21.39 12.58L16.95 17L13 18L13.99 14.05L18.42 9.60998Z"
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
